module.exports = __webpack_public_path__ + "static/media/atlantic-wave.39f93a3e.svg";